import type { CitiesData } from '~/types/city'

export default {
  popular: [
    { id: '7700000000000', name: 'Москва', region: 'Москва' },
    { id: '7800000000000', name: 'Санкт-Петербург', region: 'Санкт-Петербург' },
    { id: '5400000100000', name: 'Новосибирск', region: 'Новосибирская область' },
    { id: '6600000100000', name: 'Екатеринбург', region: 'Свердловская область' },
    { id: '1600000100000', name: 'Казань', region: 'Татарстан' },
    { id: '5200000100000', name: 'Нижний Новгород', region: 'Нижегородская область' },
    { id: '7400000100000', name: 'Челябинск', region: 'Челябинская область' },
    { id: '6300000100000', name: 'Самара', region: 'Самарская область' },
    { id: '5500000100000', name: 'Омск', region: 'Омская область' },
    { id: '6100000100000', name: 'Ростов-на-Дону', region: 'Ростовская область' }
  ],
  all: [
    { id: '1900000100000', name: 'Абакан', region: 'Хакасия' },
    { id: '0100000200000', name: 'Адыгейск', region: 'Адыгея' },
    { id: '8300000100000', name: 'Нарьян-Мар', region: 'Ненецкий АО' },
    { id: '5100000200000', name: 'Апатиты', region: 'Мурманская область' },
    { id: '3800000300000', name: 'Ангарск', region: 'Иркутская область' },
    { id: '8700000100000', name: 'Анадырь', region: 'Чукотский АО' },
    { id: '2300000400000', name: 'Армавир', region: 'Краснодарский край' },
    { id: '2900000100000', name: 'Архангельск', region: 'Архангельская область' },
    { id: '3000000100000', name: 'Астрахань', region: 'Астраханская область' },
    { id: '0400000100000', name: 'Барнаул', region: 'Алтайский край' },
    { id: '5000000100000', name: 'Балашиха', region: 'Московская область' },
    { id: '5400000200000', name: 'Бердск', region: 'Новосибирская область' },
    { id: '9600000200000', name: 'Бердянск', region: 'Запорожская область' },
    { id: '3100000100000', name: 'Белгород', region: 'Белгородская область' },
    { id: '2200000200000', name: 'Бийск', region: 'Алтайский край' },
    { id: '2800000100000', name: 'Благовещенск', region: 'Амурская область' },
    { id: '7900000100000', name: 'Биробиджан', region: 'Еврейская АО' },
    { id: '3800000200000', name: 'Братск', region: 'Иркутская область' },
    { id: '3200000100000', name: 'Брянск', region: 'Брянская область' },
    { id: '0300000100000', name: 'Улан-Удэ', region: 'Бурятия' },
    { id: '0300000200000', name: 'Северобайкальск', region: 'Бурятия' },
    { id: '0200000100000', name: 'Уфа', region: 'Башкортостан' },
    { id: '0200000200000', name: 'Стерлитамак', region: 'Башкортостан' },
    { id: '0200000300000', name: 'Салават', region: 'Башкортостан' },
    { id: '7300000200000', name: 'Димитровград', region: 'Ульяновская область' },
    { id: '0500000300000', name: 'Дербент', region: 'Дагестан' },
    { id: '9300000100000', name: 'Донецк', region: 'Донецкая Народная Республика' },
    { id: '5200000200000', name: 'Дзержинск', region: 'Нижегородская область' },
    { id: '0800000100000', name: 'Элиста', region: 'Калмыкия' },
    { id: '6400000200000', name: 'Энгельс', region: 'Саратовская область' },
    { id: '4800000200000', name: 'Елец', region: 'Липецкая область' },
    { id: '6600000100000', name: 'Екатеринбург', region: 'Свердловская область' },
    { id: '4600000200000', name: 'Железногорск', region: 'Курская область' },
    { id: '2200000100000', name: 'Горно-Алтайск', region: 'Алтай' },
    { id: '0600000100000', name: 'Грозный', region: 'Чечня' },
    { id: '1000000100000', name: 'Владикавказ', region: 'Северная Осетия' },
    { id: '2500000100000', name: 'Владивосток', region: 'Приморский край' },
    { id: '3300000100000', name: 'Владимир', region: 'Владимирская область' },
    { id: '3400000100000', name: 'Волгоград', region: 'Волгоградская область' },
    { id: '3400000200000', name: 'Волжский', region: 'Волгоградская область' },
    { id: '3400000300000', name: 'Камышин', region: 'Волгоградская область' },
    { id: '3500000100000', name: 'Вологда', region: 'Вологодская область' },
    { id: '3500000200000', name: 'Череповец', region: 'Вологодская область' },
    { id: '3600000100000', name: 'Воронеж', region: 'Воронежская область' },
    { id: '1800000100000', name: 'Ижевск', region: 'Удмуртия' },
    { id: '3700000100000', name: 'Иваново', region: 'Ивановская область' },
    { id: '3700000200000', name: 'Шуя', region: 'Ивановская область' },
    { id: '0600000100000', name: 'Магас', region: 'Ингушетия' },
    { id: '3800000100000', name: 'Иркутск', region: 'Иркутская область' },
    { id: '1200000100000', name: 'Йошкар-Ола', region: 'Марий Эл' },
    { id: '4000000100000', name: 'Калуга', region: 'Калужская область' },
    { id: '0700000100000', name: 'Нальчик', region: 'Кабардино-Балкария' },
    { id: '3900000000000', name: 'Калининград', region: 'Калининградская область' },
    { id: '1000000100000', name: 'Петрозаводск', region: 'Карелия' },
    { id: '4200000200000', name: 'Кемерово', region: 'Кемеровская область' },
    { id: '4200000300000', name: 'Новокузнецк', region: 'Кемеровская область' },
    { id: '4200000400000', name: 'Прокопьевск', region: 'Кемеровская область' },
    { id: '9100000400000', name: 'Керчь', region: 'Крым' },
    { id: '9100000100000', name: 'Симферополь', region: 'Крым' },
    { id: '9100000300000', name: 'Ялта', region: 'Крым' },
    { id: '4300000100000', name: 'Киров', region: 'Кировская область' },
    { id: '4300000200000', name: 'Кирово-Чепецк', region: 'Кировская область' },
    { id: '4400000100000', name: 'Кострома', region: 'Костромская область' },
    { id: '2300000100000', name: 'Краснодар', region: 'Краснодарский край' },
    { id: '2300000200000', name: 'Сочи', region: 'Краснодарский край' },
    { id: '2300000300000', name: 'Новороссийск', region: 'Краснодарский край' },
    { id: '2400000100000', name: 'Красноярск', region: 'Красноярский край' },
    { id: '5000000400000', name: 'Королёв', region: 'Московская область' },
    { id: '4500000100000', name: 'Курган', region: 'Курганская область' },
    { id: '4500000200000', name: 'Шадринск', region: 'Курганская область' },
    { id: '4600000100000', name: 'Курск', region: 'Курская область' },
    { id: '9400000100000', name: 'Луганск', region: 'Луганская Народная Республика' },
    { id: '4800000100000', name: 'Липецк', region: 'Липецкая область' },
    { id: '0100000100000', name: 'Майкоп', region: 'Адыгея' },
    { id: '1300000100000', name: 'Саранск', region: 'Мордовия' },
    { id: '5000000200000', name: 'Подольск', region: 'Московская область' },
    { id: '5000000300000', name: 'Химки', region: 'Московская область' },
    { id: '7700000000000', name: 'Москва', region: 'Москва' },
    { id: '5100000100000', name: 'Мурманск', region: 'Мурманская область' },
    { id: '0500000100000', name: 'Махачкала', region: 'Дагестан' },
    { id: '0500000200000', name: 'Хасавюрт', region: 'Дагестан' },
    { id: '9300000200000', name: 'Мариуполь', region: 'Донецкая Народная Республика' },
    { id: '9600000100000', name: 'Мелитополь', region: 'Запорожская область' },
    { id: '5400000100000', name: 'Новосибирск', region: 'Новосибирская область' },
    { id: '5300000100000', name: 'Великий Новгород', region: 'Новгородская область' },
    { id: '5200000100000', name: 'Нижний Новгород', region: 'Нижегородская область' },
    { id: '8900000200000', name: 'Новый Уренгой', region: 'Ямало-Ненецкий АО' },
    { id: '7100000200000', name: 'Новомосковск', region: 'Тульская область' },
    { id: '8300000200000', name: 'Печора', region: 'Коми' },
    { id: '5500000100000', name: 'Омск', region: 'Омская область' },
    { id: '5600000100000', name: 'Оренбург', region: 'Оренбургская область' },
    { id: '5600000200000', name: 'Орск', region: 'Оренбургская область' },
    { id: '5600000300000', name: 'Новотроицк', region: 'Оренбургская область' },
    { id: '5700000100000', name: 'Орёл', region: 'Орловская область' },
    { id: '5800000100000', name: 'Пенза', region: 'Пензенская область' },
    { id: '5800000200000', name: 'Кузнецк', region: 'Пензенская область' },
    { id: '5900000100000', name: 'Пермь', region: 'Пермский край' },
    { id: '2500000200000', name: 'Уссурийск', region: 'Приморский край' },
    { id: '6000000100000', name: 'Псков', region: 'Псковская область' },
    { id: '6100000100000', name: 'Ростов-на-Дону', region: 'Ростовская область' },
    { id: '6100000200000', name: 'Таганрог', region: 'Ростовская область' },
    { id: '6100000300000', name: 'Шахты', region: 'Ростовская область' },
    { id: '0400000200000', name: 'Рубцовск', region: 'Алтайский край' },
    { id: '7600000200000', name: 'Рыбинск', region: 'Ярославская область' },
    { id: '6200000100000', name: 'Рязань', region: 'Рязанская область' },
    { id: '6200000200000', name: 'Касимов', region: 'Рязанская область' },
    { id: '6300000100000', name: 'Самара', region: 'Самарская область' },
    { id: '6300000200000', name: 'Тольятти', region: 'Самарская область' },
    { id: '6300000300000', name: 'Сызрань', region: 'Самарская область' },
    { id: '6400000100000', name: 'Саратов', region: 'Саратовская область' },
    { id: '7800000000000', name: 'Санкт-Петербург', region: 'Санкт-Петербург' },
    { id: '1400000100000', name: 'Якутск', region: 'Саха (Якутия)' },
    { id: '4100000100000', name: 'Южно-Сахалинск', region: 'Сахалинская область' },
    { id: '8900000100000', name: 'Салехард', region: 'Ямало-Ненецкий АО' },
    { id: '9100000200000', name: 'Севастополь', region: 'Севастополь' },
    { id: '6700000100000', name: 'Смоленск', region: 'Смоленская область' },
    { id: '2600000100000', name: 'Ставрополь', region: 'Ставропольский край' },
    { id: '3100000200000', name: 'Старый Оскол', region: 'Белгородская область' },
    { id: '1100000100000', name: 'Сыктывкар', region: 'Коми' },
    { id: '6800000100000', name: 'Тамбов', region: 'Тамбовская область' },
    { id: '1600000200000', name: 'Набережные Челны', region: 'Татарстан' },
    { id: '1600000100000', name: 'Казань', region: 'Татарстан' },
    { id: '6900000100000', name: 'Тверь', region: 'Тверская область' },
    { id: '4200000100000', name: 'Томск', region: 'Томская область' },
    { id: '7200000200000', name: 'Тобольск', region: 'Тюменская область' },
    { id: '7200000100000', name: 'Тюмень', region: 'Тюменская область' },
    { id: '1700000100000', name: 'Кызыл', region: 'Тыва' },
    { id: '7100000100000', name: 'Тула', region: 'Тульская область' },
    { id: '7400000100000', name: 'Челябинск', region: 'Челябинская область' },
    { id: '7400000200000', name: 'Магнитогорск', region: 'Челябинская область' },
    { id: '2100000100000', name: 'Чебоксары', region: 'Чувашия' },
    { id: '0900000100000', name: 'Черкесск', region: 'Карачаево-Черкесия' },
    { id: '7500000100000', name: 'Чита', region: 'Забайкальский край' },
    { id: '8600000100000', name: 'Ханты-Мансийск', region: 'Ханты-Мансийский АО' },
    { id: '8600000200000', name: 'Сургут', region: 'Ханты-Мансийский АО' },
    { id: '8600000300000', name: 'Нижневартовск', region: 'Ханты-Мансийский АО' },
    { id: '2700000100000', name: 'Хабаровск', region: 'Хабаровский край' },
    { id: '2700000200000', name: 'Комсомольск-на-Амуре', region: 'Хабаровский край' },
    { id: '3200000100000', name: 'Петропавловск-Камчатский', region: 'Камчатский край' },
    { id: '7600000100000', name: 'Ярославль', region: 'Ярославская область' },
    { id: '7300000100000', name: 'Ульяновск', region: 'Ульяновская область' }
  ]
} as CitiesData
